import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SaunaPoolIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SaunaPoolIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.4389 22.079C4.21809 22.079 2.01074 19.5822 2.01074 17.4447C2.01074 15.0862 4.29654 13.4032 8.12464 12.9422L8.26651 12.9252L8.40147 12.9707C10.6962 13.7561 13.7564 13.9691 15.7239 13.4488L15.8731 13.4097L16.0235 13.4447C17.817 13.8569 21.9891 15.0724 21.9891 17.4448C21.9891 20.4285 15.1597 22.079 10.4389 22.079ZM8.13562 14.1992C5.12379 14.5919 3.25954 15.8293 3.25954 17.4447C3.25954 19.47 6.14454 20.8302 10.4389 20.8302C15.8902 20.8302 20.7403 18.9366 20.7403 17.4447C20.7403 16.6683 19.2211 15.4854 15.8898 14.6951C13.7349 15.2228 10.5816 15.0057 8.13562 14.1992Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.1709 14.9922C11.4428 14.9922 9.55741 14.6865 7.99763 14.1532C5.64679 13.3491 4.35205 12.1865 4.35205 10.8792C4.35205 9.42956 5.95939 8.14987 8.76146 7.36855L8.98585 7.30595L9.19602 7.40595C9.73993 7.66286 10.4208 7.79295 11.2196 7.79295C12.4375 7.79295 13.7554 7.48644 14.7445 6.97261L14.927 6.8783L15.1302 6.91082C17.9591 7.35961 19.6482 8.84337 19.6482 10.8792C19.6482 12.6475 18.3006 14.0597 16.0437 14.6565C15.2018 14.8792 14.2351 14.9922 13.1709 14.9922ZM8.88545 8.63281C6.94071 9.21087 5.60085 10.1214 5.60085 10.8792C5.60085 11.5678 6.70023 12.3894 8.40147 12.9707C10.6962 13.7561 13.7564 13.9691 15.7239 13.4488C17.4239 12.9992 18.3994 12.0629 18.3994 10.8792C18.3994 9.55234 17.1811 8.54989 15.1286 8.17672C13.9957 8.72063 12.5522 9.04177 11.2196 9.04177C10.3355 9.04177 9.55172 8.90436 8.88545 8.63281Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.2196 9.04177C10.2351 9.04177 9.3742 8.87096 8.66241 8.53437C7.41077 7.94412 6.69287 6.86443 6.69287 5.57173C6.69287 3.84406 8.09248 2.10095 11.2194 2.10095C14.0983 2.10095 17.3064 3.52617 17.3064 5.57173C17.3064 6.52459 16.6007 7.41566 15.3198 8.08152C14.1609 8.68234 12.6286 9.04177 11.2196 9.04177ZM11.2194 3.34974C9.19778 3.34974 7.94166 4.20097 7.94166 5.57172C7.94166 6.37254 8.38679 7.02377 9.19534 7.40508C9.73966 7.66281 10.4208 7.79295 11.2196 7.79295C12.4375 7.79295 13.7554 7.48644 14.7445 6.97261C15.5668 6.54578 16.0576 6.02213 16.0576 5.57172C16.0576 4.59203 13.7796 3.34974 11.2194 3.34974Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SaunaPoolIcon;
